import * as actions from './actions'

const catalogLevelsOfEducationModule = {
    namespaced: true,
    actions,
}

export default catalogLevelsOfEducationModule
